module.exports = __webpack_public_path__ + "static/media/icons_rachis_dorsal.0893298a.svg";